<template>
  <div>
    <!-- <CampaignFinancialCourse v-if="$root.user.hasBalcaoMais" class="mb-4" /> -->
    <!-- <CampaignReturnToPortugal v-if="$root.user.hasBalcaoMais" class="mb-4" /> -->
    <div class="bl-bussola-medal">
      <DocumentationOverview
        v-if="$root.user.isClient"
        compact
        hide-when-empty
        :main-people="documentationMainPeople"
        :family-people="documentationFamilyPeople"
        :family-is-relation="false"
        family-show-in-client-relations
      />
      <DashboardSidebarWidgets />
      <ShowLastBussola v-if="$root.user.hasBalcaoMais" />
      <DashboardUpcomingEvents />
    </div>
    <div v-if="$root.user.hasBalcaoMais" class="bl-news">
      <News />
    </div>
  </div>
</template>

<script setup>
import {
  computed,
  defineAsyncComponent,
  getCurrentInstance,
  onMounted,
  ref,
} from "vue";
import DashboardSidebarWidgets from "./DashboardSidebarWidgets.vue";
import DocumentationOverview from "../clientDocumentations/DocumentationOverview.vue";
import { translateRelationToPt } from "../../utils/translateRelation";

const News = defineAsyncComponent(() => import("../news/News.vue"));
const DashboardUpcomingEvents = defineAsyncComponent(() =>
  import("../events/DashboardUpcomingEvents.vue")
);
const ShowLastBussola = defineAsyncComponent(() =>
  import("../bussola/ShowLastBussola.vue")
);
const documentationFamilyPeople = ref([]);
const instance = getCurrentInstance();
const root = instance.proxy.$root;

const documentationMainPeople = computed(() => {
  const user = root.user;
  if (!user || !user.id) {
    return [];
  }
  return [{ id: user.id, name: user.name, imgUrl: user.imgUrl }];
});

const loadDocumentationFamilyPeople = () => {
  const clientId = root.user && root.user.id;
  if (!clientId) {
    return;
  }

  root
    .apiGet(root.api.clientRelations, {
      params: { clientId },
    })
    .then((response) => {
      const list = (response.data && response.data.data) || [];
      const seen = new Set();
      documentationFamilyPeople.value = list
        .map((relation) => {
          const id = relation.childClientId;
          const name = relation.childClientName;
          if (!id || !name || id === clientId || seen.has(id)) {
            return null;
          }
          seen.add(id);
          return {
            id,
            name,
            relationLabel: translateRelationToPt(relation.relationship),
          };
        })
        .filter(Boolean);
    })
    .catch(() => {
      documentationFamilyPeople.value = [];
    });
};

onMounted(() => {
  if (root.user && root.user.isClient) {
    loadDocumentationFamilyPeople();
  }
});
// import CampaignReturnToPortugal from './campaign/CampaignReturnToPortugal.vue';
// import CampaignFinancialCourse from './campaign/CampaignFinancialCourse.vue';
</script>
